// @flow
import React from 'react';
import CreateAccountValueProp from 'app/common/react/components/growth/smb/CreateAccountValueProp/CreateAccountValueProp';
import i18n from 'app/common/lib/i18n';

export default () => (
  <CreateAccountValueProp
    title={i18n._('Reach people making decisions', 'Value prop statistics title')}
    sections={[
      {
        heading: i18n._('250m', 'Value prop monthly statistic heading'),
        subtitle: i18n._(
          'people use Pinterest every month',
          'Value prop monthly statistic subtitle',
        ),
      },
      {
        heading: i18n._('2b', 'Value prop search statistic heading'),
        subtitle: i18n._(
          'searches for new ideas happen on Pinterest every month',
          'Value prop search statistic subtitle',
        ),
      },
      {
        heading: i18n._('70%', 'Value prop user action statistic heading'),
        subtitle: i18n._(
          'of people are searching, clicking and saving, not just browsing',
          'Value prop user action statistic subtitle',
        ),
      },
    ]}
  />
);
